export const APPOINTMENT_STATUS = Object.freeze({
  COMPLETED: 'COMPLETED',
  ARRIVED: 'ARRIVED',
  PAUSED: 'PAUSED',
  PENDING_CUSTOMER_AUTORIZATION: 'PENDING_CUSTOMER_AUTORIZATION',
  UNKNOWN: 'UNKNOWN',
  NOT_ARRIVED: 'NOT_ARRIVED',
  IN_PROGRESS: 'IN_PROGRESS',
  REVIEWED: 'REVIEWED',
  NEW: 'new'
});



// WEBPACK FOOTER //
// ./src/constants/appointmentStatus.js